import React from 'react';
import { Dialog, useTheme } from '@mui/material';

const FormDialog = ({ open, onClose, children, maxWidth = 560 }) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          borderRadius: '16px',
          bgcolor: theme.palette.background.paper,
          backgroundImage: 'none',
          boxShadow: theme.palette.mode === 'dark'
            ? '0 24px 60px rgba(0, 0, 0, 0.8)'
            : '0 24px 60px rgba(15, 23, 42, 0.15)',
          border: `1px solid ${theme.palette.divider}`,
          overflow: 'hidden',
          width: '100%',
          maxWidth: typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth,
          maxHeight: '92vh',
          m: { xs: 1.5, sm: 2 },
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      {children}
    </Dialog>
  );
};

export default FormDialog;
